export default function (state = {sessionId: null, isAuthenticated: false, tradeportal: null}, action) {
    switch (action.type) {
        case 'CLEAR_AUTHENTICATION':
            return {
                isAuthenticated: false,
                sessionId: null,
                tradeportal: null,
            };

        case 'SET_AUTHENTICATION':
            return {
                tradeportal: null,
                ...action.authentication,
            };

        default:
            return state;
    }
}
